var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"history",staticClass:"history",attrs:{"id":_vm.id}},_vm._l((_vm.historyList),function(item){return _c('div',{key:item.id,staticClass:"historyItem"},[_vm._v(_vm._s(item.text))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }